module.exports = __webpack_public_path__ + "static/media/intro.d29b64c3.mp3";